import React from "react";
import Skeleton from "react-loading-skeleton";
import { Col, Row } from "react-bootstrap";
import 'react-loading-skeleton/dist/skeleton.css';

const ParkCardSekelton = ({ count = 4 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
     
          <Row  className="searchSafari_wraper mb-4">
            <Col xl={3} sm={3} md={3}>
              <div className="Slider_safariimg3 h-100 w-100" >
                <Skeleton height={"100%"} width={240} />
              </div>
            </Col>
            <Col xl={9} sm={9} md={9}>
              <div className="safariSearch_wrap">
                <div className="safrititles tite_parklist pt-sm-0 pt-3">
                  <Skeleton height={24} width="60%" />
                </div>
                <div className="detailesOrLocation d-flex justify-content-between py-0">
                  <div className="items_bg d-flex gap-1">
                    <Skeleton height={20} width={20} />
                    <div className="d-flex flex-column">
                      <Skeleton height={12} width={60} />
                      <Skeleton height={14} width={120} />
                    </div>
                  </div>
                  <div className="items_bg d-flex gap-1">
                    <Skeleton height={20} width={20} />
                    <div className="d-flex flex-column">
                      <Skeleton height={12} width={80} />
                      <Skeleton height={14} width={120} />
                    </div>
                  </div>
                  <div className="items_bg d-flex gap-1">
                    <Skeleton height={20} width={20} />
                    <div className="d-flex flex-column">
                      <Skeleton height={12} width={80} />
                      <Skeleton height={14} width={100} />
                    </div>
                  </div>
                </div>
                <div className="seelctes_text pt-1 pb-0">
                  <Skeleton count={2} height={10} width="100%" />
                </div>
                <div className="touroprators text-center">
                  <Skeleton height={15} width={100} borderRadius={20} />
                </div>
              </div>
            </Col>
          </Row>
        
      ))}
    </>
  );
};

export default ParkCardSekelton;
